// @packages
import React from 'react';
import ReactDOM from 'react-dom/client';

// @app
import SfuminoApp from './SfuminoApp';

// @own
import './styles.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SfuminoApp />
  </React.StrictMode>
);
